import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatSnackBarRef } from '@angular/material/snack-bar';
import { TranslocoModule } from '@jsverse/transloco';

/** Snackbar shown when the browser has blocked local network access, preventing the instance configuration from loading. */
@Component({
  selector: 'app-local-network-access-blocked-snackbar',
  templateUrl: './local-network-access-blocked-snackbar.component.html',
  styleUrls: ['./local-network-access-blocked-snackbar.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [CommonModule, MatIconModule, MatButtonModule, TranslocoModule],
})
export class LocalNetworkAccessBlockedSnackbarComponent {
  constructor(
    public snackBarReference: MatSnackBarRef<LocalNetworkAccessBlockedSnackbarComponent>
  ) {}

  /** Dismiss the snackbar. */
  dismiss(): void {
    this.snackBarReference.dismiss();
  }

  /** Open the help documentation for local network access in a new tab. */
  moreInfo(): void {
    window.open(`https://square9.to/local-network-access`, '_blank');
  }
}
